export default __webpack_public_path__ + "static/media/svg-pin.152ca45b.svg";